var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "card mt-2 d-block shadow-sm"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_vm._v("推薦商品")]), _c('swiper', {
    staticClass: "product-carousel",
    attrs: {
      "options": {
        slidesPerView: 'auto',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  }, [_vm._l(_vm.recommends, function (p) {
    return _c('swiper-slide', {
      key: p.name,
      staticClass: "product-carousel__item p-2 py-3 d-flex flex-column"
    }, [_c('div', {
      staticClass: "product__photo"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": "https://picsum.photos/200?".concat(Math.random())
      }
    })]), _c('div', {
      staticClass: "product-carousel__item__title product__title"
    }, [_vm._v(" " + _vm._s(p.title) + " ")]), _c('div', {
      staticClass: "\n          product-carousel__item__price\n            flex-fill\n            d-flex\n            flex-column\n            justify-content-end\n          "
    }, [_c('div', {
      staticClass: "oprice mr-1"
    }, [_vm._v(_vm._s(p.oprice))]), _c('div', {
      staticClass: "price"
    }, [_vm._v(_vm._s(p.price))])]), _c('button', {
      staticClass: "p-2 btn product-carousel__item__purchase mt-2"
    }, [_vm._v("加購")])]);
  }), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _c('div', {
    staticClass: "sticky-bottom"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center p-3"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-secondary btn-lg m-1",
    attrs: {
      "to": {
        name: 'LiffShopFinished'
      }
    }
  }, [_vm._v(" 查看訂單 ")]), _c('router-link', {
    staticClass: "btn w-100 btn-primary btn-lg m-1",
    attrs: {
      "to": {
        name: 'LiffShopProducts'
      }
    }
  }, [_vm._v(" 繼續購物 ")])], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-5 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-check-circle.svg")
    }
  }), _c('div', {
    staticClass: "mt-3 font-weight-bold"
  }, [_vm._v("訂購完成")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card mt-2 shadow-sm"
  }, [_c('div', {
    staticClass: "p-3 detail"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('span', [_vm._v("訂單號碼")]), _c('span', {
    staticClass: "s-text-primary font-weight-bold"
  }, [_vm._v("240117003262")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("付款方式")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("信用卡一次付清")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("收件人")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("黃智彬")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("收件地址")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("新北市永和區永和路一段111號2樓")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("收件電話")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("0911111450")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("發票類型")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("個人-手機條碼載具")])]), _c('div', {
    staticClass: "d-flex justify-content-between mt-2"
  }, [_c('span', [_vm._v("訂單金額")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("NT$ 3,560")])])])]);
}]

export { render, staticRenderFns }